import script from "./SurveyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyCard.vue?vue&type=script&setup=true&lang=js"

import "./SurveyCard.vue?vue&type=style&index=0&id=a1494118&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1494118"]])

export default __exports__